export default class ExternalPaymentApiModel {
  constructor({ Amount, Description, PaymentMethod }) {
    this.Amount = Amount
    this.Description = Description
    this.PaymentMethod = PaymentMethod
  }
}
